/**
 * Application Constants
 * CCH Care - Version 1.0
 * Must stay in sync with cch-care-api/config/constants.php
 */

export const APP_NAME = 'CCH Care';

// Session timeout (HIPAA: 15 minutes)
export const SESSION_TIMEOUT_MS = 15 * 60 * 1000;
export const SESSION_WARNING_MS = 2 * 60 * 1000; // Warn 2 min before timeout

// Assistance levels
export const ASSIST_LEVELS = [
  { code: 'I', label: 'Independent', color: '#2ECC71', bg: '#E8F8F0' },
  { code: 'A', label: 'Assisted', color: '#1B6B93', bg: '#E8F4F8' },
  { code: 'D', label: 'Dependent', color: '#E67E22', bg: '#FEF5E7' },
  { code: 'R', label: 'Refused', color: '#E74C3C', bg: '#FDEDEC' },
];

// Hygiene task types
export const HYGIENE_TASKS = [
  { key: 'oral_care', label: 'Oral Care', icon: '🪥' },
  { key: 'bathing', label: 'Bathing', icon: '🚿' },
  { key: 'perineal_care', label: 'Perineal Care', icon: '🧴' },
  { key: 'grooming', label: 'Grooming', icon: '✂️' },
  { key: 'dressing', label: 'Dressing', icon: '👕' },
  { key: 'nail_care', label: 'Nail Care', icon: '💅' },
];

// Meal types
export const MEAL_TYPES = ['Breakfast', 'Lunch', 'Dinner'];

// Fluid types
export const FLUID_TYPES = ['Water', 'Juice', 'Coffee', 'Milk', 'Thickened'];
export const FLUID_PRESETS = [60, 120, 240, 360]; // mL

// Repositioning positions
export const POSITIONS = ['left', 'right', 'back', 'elevated', 'chair'];

// Bowel sizes
export const BOWEL_SIZES = [
  { code: 'S', label: 'Small' },
  { code: 'M', label: 'Medium' },
  { code: 'L', label: 'Large' },
];

// Urination types
export const URINE_TYPES = [
  { code: 'voided', label: 'Voided', icon: '🚽' },
  { code: 'incontinent', label: 'Incontinent', icon: '⚠️' },
  { code: 'catheter', label: 'Catheter', icon: '🏥' },
];

// Safety checklist categories
export const SAFETY_CATEGORIES = ['Patient Safety', 'Environment', 'PPE'];

// ADL record statuses
export const ADL_STATUS = {
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
  AMENDED: 'amended',
};

// Alert severities
export const ALERT_SEVERITY = {
  INFO: 'info',
  WARNING: 'warning',
  CRITICAL: 'critical',
};

// Color tokens (matches prototype)
export const COLORS = {
  primary: '#1B6B93',
  primaryLight: '#E8F4F8',
  primaryDark: '#12516F',
  accent: '#2ECC71',
  accentLight: '#E8F8F0',
  warning: '#E67E22',
  warningLight: '#FEF5E7',
  danger: '#E74C3C',
  dangerLight: '#FDEDEC',
  text: '#1A2332',
  textMuted: '#6B7B8D',
  textLight: '#94A3B8',
  bg: '#F0F2F5',
  surface: '#FFFFFF',
  border: '#E2E8F0',
};
